// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1200px) {
  .OrderLayout_orderLayout__XcqFU {
    display: flex;
    flex-direction: column;
    gap: 24px;
    background: white;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    overflow: auto;
    padding: 24px 16px 80px 16px;
  }
  .OrderLayout_orderLayout__XcqFU .paper-layout-main {
    border-radius: 0;
    box-shadow: none;
  }
  .OrderLayout_orderLayout__XcqFU .paper-layout-main .paper__main {
    padding: 0;
  }
}

.OrderLayout_header__-y\\+PM {
  margin-bottom: 16px;
}

.OrderLayout_headerLoader__FSQys {
  height: 130px;
  border-radius: 12px;
  margin-bottom: 16px;
}

.OrderLayout_mainLoader__VMMCm {
  height: 300px;
  border-radius: 12px;
}

.OrderLayout_headerBtn__u3d\\+f {
  background-color: var(--accent-color);
  color: var(--accent-text-color);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  transition: var(--transition);
  margin-left: auto;
  font-size: 12px;
  font-weight: 500;
  padding: 16px;
  line-height: 100%;
}
@media (hover: hover) {
  .OrderLayout_headerBtn__u3d\\+f:hover {
    opacity: 0.8;
  }
}
@media (min-width: 640px) {
  .OrderLayout_headerBtn__u3d\\+f {
    max-width: 204px;
    font-size: 14px;
    font-weight: 400;
    padding: 12px 20px;
  }
}

.OrderLayout_headerTitle__wrSIC {
  margin-bottom: 8px;
}

.OrderLayout_headerDescription__puYnL {
  font-size: var(--fz-lg);
  line-height: 144%;
  margin-bottom: 10px;
}

.OrderLayout_mainTitle__4UW4P {
  margin-bottom: 4px;
}

.OrderLayout_description__5AGvn {
  font-size: var(--fz-lg);
  line-height: var(--lh-lg);
  margin-bottom: 4px;
}
@media (min-width: 640px) {
  .OrderLayout_description__5AGvn {
    margin-bottom: 14px;
  }
}

.OrderLayout_object__X1FPp {
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .OrderLayout_object__X1FPp {
    margin-bottom: 20px;
  }
}

.OrderLayout_block__8eNMX,
.OrderLayout_item__wv6L5 {
  margin-bottom: 8px;
}
@media (min-width: 1200px) {
  .OrderLayout_block__8eNMX,
  .OrderLayout_item__wv6L5 {
    margin-bottom: 16px;
  }
}

.OrderLayout_item__wv6L5 {
  display: flex;
  font-size: var(--fz-lg);
  line-height: var(--lh-lg);
  border-bottom: 1px solid #F3F2F2;
  padding-bottom: 8px;
  flex-direction: column;
}
@media (min-width: 1200px) {
  .OrderLayout_item__wv6L5 {
    border: none;
    padding-bottom: 0;
    flex-direction: row;
  }
}

.OrderLayout_itemTxt__R6003 {
  font-size: 12px;
  line-height: 114%;
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderLayout_itemTxt__R6003 {
    font-weight: 500;
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
    color: var(--text-color);
  }
}

.OrderLayout_itemDots__Lk3Ps {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  min-width: 100px;
  margin: 0 8px;
  display: none;
}
.OrderLayout_itemDots__Lk3Ps::before {
  content: "....................................................................................................................................................................................................................................................................................................................................................";
  color: #CACBCE;
}
@media (min-width: 1200px) {
  .OrderLayout_itemDots__Lk3Ps {
    display: flex;
  }
}

.OrderLayout_itemVal__FXUSz {
  line-height: 144%;
}
@media (min-width: 1200px) {
  .OrderLayout_itemVal__FXUSz {
    flex-shrink: 0;
    max-width: 370px;
    line-height: var(--lh-lg);
  }
}
.OrderLayout_itemVal--type-text__q-WFp {
  white-space: pre-line;
}

.OrderLayout_content__mkhVo {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
}
.OrderLayout_content__mkhVo a {
  color: var(--accent-color);
  text-decoration: underline;
}
.OrderLayout_content__mkhVo ul, .OrderLayout_content__mkhVo ol {
  margin: 0;
  padding: 0;
  padding-left: 16px;
}
.OrderLayout_content__mkhVo img {
  max-width: 100%;
}
.OrderLayout_content__mkhVo table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.OrderLayout_content__mkhVo table td, .OrderLayout_content__mkhVo table th {
  min-width: 1em;
  border: 2px solid #ced4da;
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
.OrderLayout_content__mkhVo table td > *, .OrderLayout_content__mkhVo table th > * {
  margin-bottom: 0;
}
.OrderLayout_content__mkhVo table th {
  font-weight: 700;
  text-align: left;
  background-color: #f1f3f5;
}
.OrderLayout_content__mkhVo p {
  min-height: 20px;
}
.OrderLayout_content__mkhVo h1, .OrderLayout_content__mkhVo h2, .OrderLayout_content__mkhVo h3 {
  color: #303030;
}
.OrderLayout_content__mkhVo pre {
  background: #2b2a2a;
  color: #fff;
  padding: 8px;
  display: flex;
  border-radius: 8px;
  width: 100%;
  white-space: pre-wrap;
}
.OrderLayout_content__mkhVo code {
  width: 100%;
  display: block;
  color: #fff;
  background-color: #f1f3f5;
}

.OrderLayout_fileGrid__eslZN {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 8px;
  padding-top: 8px;
}

.OrderLayout_imgGrid__VtI1L {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(2, 1fr);
  padding-top: 8px;
}
@media (min-width: 640px) {
  .OrderLayout_imgGrid__VtI1L {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1200px) {
  .OrderLayout_imgGrid__VtI1L {
    grid-template-columns: repeat(6, 1fr);
  }
}

.OrderLayout_imgWrap__5OWHY {
  height: 104px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.OrderLayout_imgWrap__5OWHY img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.OrderLayout_footer__PmUso {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/OrderLayout/OrderLayout.module.scss"],"names":[],"mappings":"AACE;EADF;IAEI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;IACA,OAAA;IACA,MAAA;IACA,WAAA;IACA,cAAA;IACA,4BAAA;EACF;EAEI;IACE,gBAAA;IACA,gBAAA;EAAN;EAEM;IACE,UAAA;EAAR;AACF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;AAHF;;AAMA;EACE,qCAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AAHF;AAKE;EACE;IACE,YAAA;EAHJ;AACF;AAME;EArBF;IAsBI,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;EAHF;AACF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,iBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;AAHF;AAKE;EALF;IAMI,mBAAA;EAFF;AACF;;AAKA;EACE,mBAAA;AAFF;AAIE;EAHF;IAII,mBAAA;EADF;AACF;;AAIA;;EAEE,kBAAA;AADF;AAGE;EAJF;;IAKI,mBAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;AACF;AACE;EARF;IASI,YAAA;IACA,iBAAA;IACA,mBAAA;EAEF;AACF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAEF;AAAE;EALF;IAMI,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,wBAAA;EAGF;AACF;;AAAA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;AAGF;AADE;EACE,+VAAA;EACA,cAAA;AAGJ;AAAE;EAbF;IAcI,aAAA;EAGF;AACF;;AAAA;EACE,iBAAA;AAGF;AADE;EAHF;IAII,cAAA;IACA,gBAAA;IACA,yBAAA;EAIF;AACF;AAFE;EACE,qBAAA;AAIJ;;AAAA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAGF;AADE;EACE,0BAAA;EACA,0BAAA;AAGJ;AADE;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AAGJ;AAAE;EACE,eAAA;AAEJ;AAAE;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AAEJ;AACE;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EAGE,cAAA;AALJ;AAOE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AALJ;AAOE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AALJ;;AASA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;EACA,gBAAA;AANF;AAQI;EANJ;IAOM,qCAAA;EALJ;AACF;AAOE;EAVF;IAWI,qCAAA;EAJF;AACF;;AAOA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAJF;AAME;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AALF","sourcesContent":[".orderLayout {\r\n  @media (max-width: 1200px) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 24px;\r\n    background: white;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    overflow: auto;\r\n    padding: 24px 16px 80px 16px;\r\n  \r\n    :global {\r\n      .paper-layout-main {\r\n        border-radius: 0;\r\n        box-shadow: none;\r\n  \r\n        .paper__main {\r\n          padding: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.header {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.headerLoader {\r\n  height: 130px;\r\n  border-radius: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.mainLoader {\r\n  height: 300px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.headerBtn {\r\n  background-color: var(--accent-color);\r\n  color: var(--accent-text-color);\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 12px;\r\n  transition: var(--transition);\r\n  margin-left: auto;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  padding: 16px;\r\n  line-height: 100%;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    max-width: 204px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    padding: 12px 20px;\r\n  }\r\n}\r\n\r\n.headerTitle {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.headerDescription {\r\n  font-size: var(--fz-lg);\r\n  line-height: 144%;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mainTitle {\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.description {\r\n  font-size: var(--fz-lg);\r\n  line-height: var(--lh-lg);\r\n  margin-bottom: 4px;\r\n\r\n  @media (min-width: 640px) {\r\n    margin-bottom: 14px;\r\n  }\r\n}\r\n\r\n.object {\r\n  margin-bottom: 24px;\r\n\r\n  @media (min-width: 640px) {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n.block,\r\n.item {\r\n  margin-bottom: 8px;\r\n\r\n  @media (min-width: 1200px) {\r\n    margin-bottom: 16px;\r\n  }\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  font-size: var(--fz-lg);\r\n  line-height: var(--lh-lg);\r\n  border-bottom: 1px solid #F3F2F2;\r\n  padding-bottom: 8px;\r\n  flex-direction: column;\r\n\r\n  @media (min-width: 1200px) {\r\n    border: none;\r\n    padding-bottom: 0;\r\n    flex-direction: row;\r\n  }\r\n}\r\n\r\n.itemTxt {\r\n  font-size: 12px;\r\n  line-height: 114%;\r\n  color: #54575C;\r\n\r\n  @media (min-width: 1200px) {\r\n    font-weight: 500;\r\n    font-size: var(--fz-lg);\r\n    line-height: var(--lh-lg);\r\n    color: var(--text-color);\r\n  }\r\n}\r\n\r\n.itemDots {\r\n  flex: 1;\r\n  position: relative;\r\n  overflow: hidden;\r\n  min-width: 100px;\r\n  margin: 0 8px;\r\n  display: none;\r\n\r\n  &::before {\r\n    content: '....................................................................................................................................................................................................................................................................................................................................................';\r\n    color: #CACBCE;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n.itemVal {\r\n  line-height: 144%;\r\n\r\n  @media (min-width: 1200px) {\r\n    flex-shrink: 0;\r\n    max-width: 370px;\r\n    line-height: var(--lh-lg);\r\n  }\r\n\r\n  &--type-text {\r\n    white-space: pre-line;\r\n  }\r\n}\r\n\r\n.content {\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 144%;\r\n\r\n  a {\r\n    color: var(--accent-color);\r\n    text-decoration: underline;\r\n  }\r\n  ul, ol{\r\n    margin: 0;\r\n    padding: 0;\r\n    padding-left: 16px;\r\n  }\r\n\r\n  img {\r\n    max-width: 100%;\r\n  }\r\n  table {\r\n    border-collapse: collapse;\r\n    table-layout: fixed;\r\n    width: 100%;\r\n    margin: 0;\r\n    overflow: hidden\r\n  }\r\n\r\n  table td,table th {\r\n    min-width: 1em;\r\n    border: 2px solid #ced4da;\r\n    padding: 3px 5px;\r\n    vertical-align: top;\r\n    box-sizing: border-box;\r\n    position: relative\r\n  }\r\n\r\n  table td>*,table th>* {\r\n    margin-bottom: 0\r\n  }\r\n\r\n  table th {\r\n    font-weight: 700;\r\n    text-align: left;\r\n    background-color: #f1f3f5\r\n  }\r\n\r\n  p {\r\n    min-height: 20px;\r\n  }\r\n\r\n  & h1,\r\n  & h2,\r\n  & h3 {\r\n    color: #303030;\r\n  }\r\n  pre {\r\n    background: #2b2a2a;\r\n    color: #fff;\r\n    padding: 8px;\r\n    display: flex;\r\n    border-radius: 8px;\r\n    width: 100%;\r\n    white-space: pre-wrap;\r\n  }\r\n  code {\r\n    width: 100%;\r\n    display: block;\r\n    color: #fff;\r\n    background-color: #f1f3f5;\r\n  }\r\n}\r\n\r\n.fileGrid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  grid-gap: 8px;\r\n  padding-top: 8px;\r\n}\r\n\r\n.imgGrid {\r\n  display: grid;\r\n  grid-gap: 8px;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  padding-top: 8px;\r\n\r\n    @media (min-width: 640px) {\r\n      grid-template-columns: repeat(4, 1fr);\r\n    }\r\n\r\n  @media (min-width: 1200px) {\r\n    grid-template-columns: repeat(6, 1fr);\r\n  }\r\n}\r\n\r\n.imgWrap {\r\n  height: 104px;\r\n  border-radius: 8px;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n\r\n  img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n  }\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  padding-top: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderLayout": `OrderLayout_orderLayout__XcqFU`,
	"header": `OrderLayout_header__-y+PM`,
	"headerLoader": `OrderLayout_headerLoader__FSQys`,
	"mainLoader": `OrderLayout_mainLoader__VMMCm`,
	"headerBtn": `OrderLayout_headerBtn__u3d+f`,
	"headerTitle": `OrderLayout_headerTitle__wrSIC`,
	"headerDescription": `OrderLayout_headerDescription__puYnL`,
	"mainTitle": `OrderLayout_mainTitle__4UW4P`,
	"description": `OrderLayout_description__5AGvn`,
	"object": `OrderLayout_object__X1FPp`,
	"block": `OrderLayout_block__8eNMX`,
	"item": `OrderLayout_item__wv6L5`,
	"itemTxt": `OrderLayout_itemTxt__R6003`,
	"itemDots": `OrderLayout_itemDots__Lk3Ps`,
	"itemVal": `OrderLayout_itemVal__FXUSz`,
	"itemVal--type-text": `OrderLayout_itemVal--type-text__q-WFp`,
	"content": `OrderLayout_content__mkhVo`,
	"fileGrid": `OrderLayout_fileGrid__eslZN`,
	"imgGrid": `OrderLayout_imgGrid__VtI1L`,
	"imgWrap": `OrderLayout_imgWrap__5OWHY`,
	"footer": `OrderLayout_footer__PmUso`
};
export default ___CSS_LOADER_EXPORT___;
